import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8e8c960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-background w-screen h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = { class: "pageHeader flex justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_5 = { class: "grid grid-cols-2 gap-4 mt-4 content w-100" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "report-background w-screen h-screen" }
const _hoisted_11 = { class: "flex flex-col justify-between" }
const _hoisted_12 = { class: "pageHeader flex justify-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_14 = { class: "grid grid-cols-2 gap-4 mt-4 content w-100" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_page_bottom = _resolveComponent("page-bottom")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_page_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            Title: 'Fotos'
          }, null, 8, ["ba", "immobilie"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.header), 1),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_ctx.getPhotoUrl(_ctx.sortedImages[0]))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getPhotoUrl(_ctx.sortedImages[0]),
                    alt: "Image 1",
                    class: "w-full h-auto bg-white border"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.getPhotoUrl(_ctx.sortedImages[2]))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.getPhotoUrl(_ctx.sortedImages[2]),
                    alt: "Image 1",
                    class: "w-full h-auto bg-white border"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.getPhotoUrl(_ctx.sortedImages[1]))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _ctx.getPhotoUrl(_ctx.sortedImages[1]),
                    alt: "Image 1",
                    class: "w-full h-auto bg-white border"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.getPhotoUrl(_ctx.sortedImages[3]))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: _ctx.getPhotoUrl(_ctx.sortedImages[3]),
                    alt: "Image 1",
                    class: "w-full h-auto bg-white border"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_page_bottom)
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    (_ctx.sortedImages[4] != null)
      ? (_openBlock(), _createBlock(_component_pdf_a4_page, {
          key: 0,
          "no-margin": "",
          "pdf-key": _ctx.lang
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_page_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                Title: 'Fotos'
              }, null, 8, ["ba", "immobilie"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.header), 1),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.getPhotoUrl(_ctx.sortedImages[4]))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getPhotoUrl(_ctx.sortedImages[4]),
                        alt: "Image 1",
                        class: "w-full h-auto bg-white border"
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_page_bottom)
            ])
          ]),
          _: 1
        }, 8, ["pdf-key"]))
      : _createCommentVNode("", true)
  ], 64))
}